module.exports = __webpack_public_path__ + "img/25.4096cde3.png";